export const mockCouriers = [
  {
    id: 35360,
    workspace_id: 1,
    store_id: 12,
    name: "Leopards",
    name_id: 1,
    daily_limit: 100,
    low_value_orders: false,
    priority: 1,
    function_value: "leopards",
    status: "Approved",
    approved_by: 4,
    isActive: true,
    isApproved: true,
    account: "LEO-100234",
    pickup_address_id: "PK-8841",
    createdAt: "2026-09-02T09:15:00.000Z",
    updatedAt: "2026-10-20T14:30:00.000Z",
  },
  {
    id: 35361,
    workspace_id: 1,
    store_id: 12,
    name: "PostEx",
    name_id: 2,
    daily_limit: 50,
    low_value_orders: true,
    priority: 2,
    function_value: "postex",
    status: "Approved",
    approved_by: 4,
    isActive: false,
    isApproved: true,
    account: "PEX-55021",
    pickup_address_id: "PK-8842",
    createdAt: "2026-09-10T11:00:00.000Z",
    updatedAt: "2026-10-18T08:45:00.000Z",
  },
  {
    id: 35362,
    workspace_id: 1,
    store_id: 12,
    name: "Trax",
    name_id: 3,
    daily_limit: 0,
    low_value_orders: false,
    priority: 3,
    function_value: "trax",
    status: "Pending",
    approved_by: null,
    isActive: false,
    isApproved: false,
    account: "TRX-90317",
    pickup_address_id: null,
    createdAt: "2026-10-22T16:20:00.000Z",
    updatedAt: "2026-10-22T16:20:00.000Z",
  },
];
